module.exports = __webpack_public_path__ + "static/media/galeryDoors4.30f45dfe.jpg";